<template>
  <v-divider class="info mt-5" />
</template>

<script>
export default {
  name: "CustomDivider",
};
</script>

<style scoped></style>
